export const TIPO_MENSAGEM = {
  CERTIDAO_NEGATIVA: 'Certidão negativa',
  CERTIDAO_MATRICULA: 'Certidão de matrícula',
  LEGITIMIDADE_TITULO: 'Legitimidade de título',
  LIBERACAO_CONDICOES: 'Liberações de condições resolutivas no titulo',
  VTN: 'VTN',
  DIREITO_ITERPA: 'Direito de preferência do Iterpa',
  MANIFESTACAO: 'Manifestação procedimento requalificação matrícula',
  OUTROS: 'Outros'
}

export const STATUS_MENSAGEM = {
  TODAS: 'Todas',
  AGUARDANDO_RESPOSTA_CARTORIO: 'Encaminhada',
  AGUARDANDO_RESPOSTA_SICARF: 'Aguardando resposta',
  FINALIZADA: 'Finalizada'
}
export const ORIGEM = {
  SICARF: 'Iterpa',
  CARTORIO: 'Cartórios'
}

export const OBJ_TIPO_MENSAGEM = [
  { id: 0, codigo: 'CERTIDAO_NEGATIVA', nome: TIPO_MENSAGEM.CERTIDAO_NEGATIVA, dias: -1 },
  { id: 1, codigo: 'CERTIDAO_MATRICULA', nome: TIPO_MENSAGEM.CERTIDAO_MATRICULA, dias: -1 },
  { id: 2, codigo: 'LEGITIMIDADE_TITULO', nome: TIPO_MENSAGEM.LEGITIMIDADE_TITULO, dias: 5 },
  { id: 4, codigo: 'LIBERACAO_CONDICOES', nome: TIPO_MENSAGEM.LIBERACAO_CONDICOES, dias: 5 },
  { id: 5, codigo: 'VTN', nome: TIPO_MENSAGEM.VTN, dias: 5 },
  { id: 6, codigo: 'DIREITO_ITERPA', nome: TIPO_MENSAGEM.DIREITO_ITERPA, dias: 15 },
  { id: 7, codigo: 'MANIFESTACAO', nome: TIPO_MENSAGEM.MANIFESTACAO, dias: 60 },
  { id: 8, codigo: 'OUTROS', nome: TIPO_MENSAGEM.OUTROS, dias: -1 }
]



// WEBPACK FOOTER //
// ./src/constants/cartoriosArrecadacao.js